// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3X6VC","dragIcon":"Choice_dragIcon__F-fMj","left":"Choice_left__2oZEE","input":"Choice_input__3wQHi"};